module.exports = __webpack_public_path__ + "img/Number=103.bf6cd86a.png";